module.exports = __webpack_public_path__ + "media/hem.73279982.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hem.svg
// module id = 493
// module chunks = 0